export const unwrapHubHttpError = error => {
  if (error && error.networkError) {
    return error.networkError;
  }

  return null;
};